import { toStatisticNumber } from 'utils/statisticNumber';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import routerActions from 'app/routerActions';
import { api, apiUtils } from 'app/services';
import * as actions from 'app/actions';
import {
KBLoadingContainer,
KBAvatar,
KBRangeDate,
KBPopover,
KBTipsy } from
'components';
import * as selectors from 'app/selectors';
import { KBDropSelect } from 'components/plugins';
import dayjs from 'utils/dayjs';
import { TASK_SUBTYPES } from 'app/constants';
import { InitialHighCharts } from 'components/mixins';
import { percent } from 'utils/kbUtil';
import {
extendDefaultHighchartsConfig,
getStatisticInitialDate,
getInitialDate } from
'utils/kbData';

const OBJ_TYPE = {
  '1_2': '1~2人',
  '3_5': '3~5人',
  '5_10': '5~10人',
  '10_20': '10~20人',
  '20_40': '20~40人',
  '40_100': '40~100人',
  '100_more': '100人以上' };


var StatisticOrgMemberStatistic = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.parseLoadFromTo = this.parseLoadFromTo.bind(this);this._loadData = this._loadData.bind(this);this.parseJSON = this.parseJSON.bind(this);this.parseHightChartData = this.parseHightChartData.bind(this);this.fillChart = this.fillChart.bind(this);this.selectCallBack = this.selectCallBack.bind(this);this._setFilters = this._setFilters.bind(this);this.changeDate = this.changeDate.bind(this);this.setMonthFilters = this.setMonthFilters.bind(this);}getInitialState()


  {
    const { from, to } = getStatisticInitialDate(new Date(), 'monthly');

    return {
      filters: {
        from,
        cycle: 'daily',
        to },

      dataOut: [],
      orgMember: [],
      month: '' };

  }componentDidMount()
  {
    const { filters, dataOut } = this.state;
    let Highcharts = this.getHighcharts();
    let filtersMonths = dayjs(filters.to).diff(dayjs(filters.from), 'months');

    this.mounted = true;
    this.setState({
      month: filtersMonths });

    this._loadData(filters);
    this.renderChart(
    'Chart',
    extendDefaultHighchartsConfig({
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie' },

      title: {
        text: null },

      tooltip: {
        pointFormat: '所占比率: <b>{point.percentage:.1f}%</b>' },

      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
            style: {
              color:
              Highcharts.theme && Highcharts.theme.contrastTextColor ||
              'black' } } } } }));






  }componentWillUnmount()

  {
    this.mounted = false;
  }parseLoadFromTo(


  params, from, to) {
    delete params.from;
    delete params.to;

    params.start_date = from ? getInitialDate(from).initStartDateString : null;
    params.end_date = to ? getInitialDate(to).initEndDateString : null;

    return params;
  }_loadData(

  filters) {
    const { locations } = this.props;
    const { from, to, location_ids, cycle } = filters;

    var params = { location_ids, cycle };
    if (!location_ids && locations) {
      params.location_ids = locations.map(json => json.id).join(',');
    }

    // 判断日期
    params = this.parseLoadFromTo(params, from, to);

    api.getOrgMemberStatistic(params).then(({ json }) => {
      this.parseJSON(json);
    });
  }parseJSON(

  json) {
    let dataOut = [];

    if (!json || !Object.keys(json).length) {
      if (this.mounted) {
        this.setState({
          dataOut });

      }
    }

    var array = Object.keys(json);

    array.forEach(str => {
      let name = str.substr(str.indexOf('t_') + 2, str.length);
      let t = {};
      t.name = OBJ_TYPE[name];
      t.value = toStatisticNumber(json[str]);
      dataOut.push(t);
    });
    if (this.mounted) {
      this.setState({
        orgMember: dataOut });

    }
    this.parseHightChartData(dataOut);
  }parseHightChartData(

  data) {
    let colors = this.getHighChartColor();
    let Highcharts = this.getHighcharts();
    let dataOut = [];
    let count = 0;

    data.forEach(json => {
      count = count + toStatisticNumber(json.value);
    });
    let dt = {
      colorByPoint: true,
      size: '80%',
      innerSize: '60%',
      data: [] };

    data.forEach((json, index) => {
      let y = parseFloat(percent(count, json.value));

      if (!y) {
        return;
      }

      let name = json.name;
      let color = colors[index];

      dt.name = name;
      dt.data.push({
        name: name,
        y: y,
        color: color });

    });
    dataOut.push(dt);

    if (this.mounted) {
      this.setState({
        dataOut });

    }

    this.fillChart(dataOut);
  }fillChart(

  dataOut) {
    this.setSerierDate(dataOut);
  }selectCallBack(

  data) {
    this._setFilters({
      location_ids: data.map(json => json.id).join(',') });

  }_setFilters(

  obj) {
    let newFilters = Object.assign({}, this.state.filters, obj);
    this.setState({
      filters: newFilters });

    this._loadData(newFilters);
  }changeDate(

  range) {
    this._setFilters(range);
    this.setState({
      month: '' });

  }setMonthFilters(

  num = 1) {
    var to = dayjs().toDate();
    var from = dayjs().
    subtract(num, 'months').
    toDate();

    this.setState({
      month: num });


    this._setFilters({
      from,
      to });

  }render()

  {
    const { locations } = this.props;
    const { filters, dataInner, dataOut, orgMember, month } = this.state;
    const { from, to } = filters;
    return (
      <article className="clear-fix">
        <div className="chart-title m-top-lg">
          <span>公司的人数饼图</span>
          <button className="bordered-btn-small" onClick={this.print}>
            <i className="iconfont icon-contract" />
            打印
          </button>
          <button className="bordered-btn-small" onClick={this.exportingExcel}>
            <i className="iconfont icon-EXCEL" />
            导出Excel
          </button>
        </div>
        <div className="m-bottom-sm">
          <KBRangeDate
          format="YYYY/MM/DD"
          from={from || ''}
          to={to || ''}
          callback={this.changeDate}
          leftNone={true} />

          <div className="time-filter">
            <button
            className={month == 1 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 1)}>

              1个月
            </button>
            <button
            className={month == 3 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 3)}>

              3个月
            </button>
            <button
            className={month == 6 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 6)}>

              6个月
            </button>
            <button
            className={month == 12 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 12)}>

              1年
            </button>
          </div>
          <KBDropSelect
          options={{ defaultSelectPrompt: '选择分店' }}
          defaultData={locations}
          multi={true}
          callback={this.selectCallBack}
          style={{ marginLeft: 20 }} />

        </div>
        <ul className="chart-data-list f-left">
          {orgMember &&
          orgMember.map((obj, index) => {
            return (
              <li key={index}>
                  <span className="f-left">{obj.name}</span>
                  <span className="f-right">{obj.value}</span>
                </li>);

          })}
        </ul>
        <div
        ref={ref => { this.highcharts = ref; }}
        className="f-right"
        style={{ width: 560, height: 350 }} />

      </article>);

  }};Object.assign(StatisticOrgMemberStatistic.prototype, InitialHighCharts);


function mapStateToProps(state, props) {
  // const locations = selectors.getSerializeLocation(state)
  const { group_id } = props;
  const locations = selectors.getSerializeGroupsLocation(state, group_id);
  return {
    locations };

}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
mapStateToProps,
mapDispatchToProps)(
StatisticOrgMemberStatistic);
